module.exports = __webpack_public_path__ + "img/pay.501b446f.png";